/* eslint-disable */
export const RECEIVE_PAGE = '@@redux-paginator/RECEIVE_PAGE'
export const REQUEST_PAGE = '@@redux-paginator/REQUEST_PAGE'
/* eslint-enable */
